import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { ImagePlaceholder } from '@core/models';
import { NgClass } from '@angular/common';
import { NameToColorPipe } from '@shared/pipes';

@Component({
  selector: 'app-image-placeholder',
  templateUrl: './image-placeholder.component.html',
  styleUrls: ['./image-placeholder.component.scss'],
  imports: [NgClass, NameToColorPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImagePlaceholderComponent implements OnInit {
  @Input() imageData: ImagePlaceholder;

  constructor() {}

  ngOnInit(): void {}
}
